export const loginGoogleApiUrl = "connect/google/usercreation";
export const getStatusUrl = "api/status";
export const generateUsernamesUrl = "api/username";
export const getAllAdGroupsUrl = "api/ldapuser/allgroups";
export const generateAdUsersUrl = "api/ldapuser";
export const getJiraTaskMetadataUrl = "api/jiraissue";
export const getOfficesUrl = "api/externalresource/offices";